/* eslint-disable react-hooks/exhaustive-deps */


import { useDispatch, useSelector } from "react-redux"
import ClientsTableRow from "../../components/clientsModal/ClientsTableRow"

import axios from "axios";
import { useEffect, useRef, useState } from "react";

import { FaAnglesLeft, FaAnglesRight } from "react-icons/fa6";
import { Skeleton } from "@/components/ui/skeleton";
import { RootState } from '../../store/store';
import { clearClientsSearchData } from "@/store/clientsSearchDataSlice";
import { IoClose } from "react-icons/io5";
import { User } from "@/types/ApiTypes";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";
import { resetPage, setPage } from "@/store/pageSlice";
import useLockBodyScroll from "@/hooks/useLockBodyScroll";
import ClientsImportModal from "@/components/clients import/ClientsImportModal";








function Clients() {
  const apps = useSelector((state: RootState) => state.apps.AppsData);
  const loyaltyApp = apps?.find((app) => app.name === "loyalty");
  const clientsSearchData = useSelector((state: RootState) => state.clientsSearchData.clientsSearchData);
  const dispatch = useDispatch();
  const baseUrl = import.meta.env.VITE_BASE_URL
  const token = useSelector((state: { auth: { token: string } }) => state.auth.token);
  const [clinetsData, setClientsData] = useState<User[]>([])
  const [clientsLoading, setClientsLoading] = useState(true)
  const [activePage, setActivePage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalClinets, setTotalClinets] = useState(0)
  const [pageNum, setPageNum] = useState(10)
  const selectRef = useRef<HTMLSelectElement>(null)
  const { t } = useTranslation();
  const lang = i18n.language;
  const currentPage = useSelector((state: RootState) => state.page.currentPage);
  const [importModalOpen, setImportModalOpen] = useState(false);
  useLockBodyScroll(importModalOpen);
  const toggleImportModal = () => {
    setImportModalOpen(!importModalOpen);
    if (importModalOpen) {
      getClientsData(1)
    }
  };


  async function getClientsData(page: number = activePage, length: number = pageNum) {
    setClientsLoading(true);
    try {
      const options = {
        url: `${baseUrl}/api/dashboard/clients?locale=${lang}&page=${page}&length=${length}`,
        method: "GET",
        headers: { Authorization: token },
      };

      const response = await axios.request(options);

      if (response.data.success) {
        const { totalPages, totalItems, page: current } = response.data.pagination;

        setTotalPages(totalPages);
        setTotalClinets(totalItems);
        setClientsData(response.data.clients);
        setActivePage(current);
        dispatch(setPage(current));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setClientsLoading(false);
    }
  }

  async function pagination(newPage: number) {
    if (newPage === activePage || newPage < 1 || newPage > totalPages) return;
    await getClientsData(newPage);
  }



  useEffect(() => {
    if (clientsSearchData) {
      setTotalPages(clientsSearchData.pagination.totalPages)
      setTotalClinets(clientsSearchData.pagination.totalItems)
      setClientsData(clientsSearchData.clients)
      setActivePage(clientsSearchData.pagination.page)
      setClientsLoading(false)
    } else if (clientsSearchData === null) {
      getClientsData(currentPage !== null ? currentPage : 1, pageNum);
    }

  }, [pageNum, clientsSearchData])
  useEffect(() => {
    if (!clientsSearchData) {

      getClientsData(currentPage !== null ? currentPage : 1, pageNum);

    }
  }, [pageNum]);
  if (clientsLoading) return (
    <>
      <div className="mt-10">
        <Skeleton className="w-full h-[40vh] dark:bg-slate-600 dark:bg-opacity-35  px-5" />
      </div>

    </>
  )
  if (clinetsData.length === 0) return (
    <>
      <Alert className="bg-skyblue dark:bg-skyblue dark:text-black">

        <AlertTitle className="text-xl text-center">{t("clients.noClientsFound")}</AlertTitle>
        <AlertDescription className="text-center my-5 font-semibold">
          {t("clients.noClientsMessage")}
        </AlertDescription>
      </Alert>
    </>
  )
  return (
    <>

      {importModalOpen && <ClientsImportModal toggleImportModal={toggleImportModal} />}

      {clientsSearchData && <> <div className="w-full md:px-8 ">

        <button onClick={() => dispatch(clearClientsSearchData())} className=" px-5 mb-5 py-2 rounded-lg text-sidebar border-sidebar border-2 ms-auto flex items-center hover:bg-sidebar hover:text-skyblue transition-colors duration-200 gap-2">{t("clients.clearSearch")} <span className="text-xl text-red-500"><IoClose />
        </span></button>
      </div></>}

      <button onClick={toggleImportModal} className="bg-skyblue text-sidebar px-5 py-2 my-5 rounded-lg ms-auto block hover:bg-sidebar hover:text-skyblue transition-colors duration-200 ">{t("clientImportModal.import")}</button>

      <div className="relative overflow-x-auto whitespace-nowrap">
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
          <thead className="text-xs text-center text-gray-700 uppercase bg-gray-50 ">
            <tr>
              <th scope="col" className="px-6 py-3">
                {t("clients.name")}
              </th>
              <th scope="col" className="px-6 py-3">
                {t("clients.phone")}              </th>
              <th scope="col" className="px-6 py-3">
                {t("clients.email")}
              </th>
              <th scope="col" className="px-6 py-3">
                {t("clients.walletPoints")}
              </th>
              {loyaltyApp?.installed &&
                <th scope="col" className="px-6 py-3">
                  {t("clients.loyaltyPoints")}
                </th>
              }
              <th scope="col" className="px-6 py-3">
                {t("clients.ordersCount")}              </th>
              <th scope="col" className="px-6 py-3">
                {t("clients.actions")}
              </th>
            </tr>
          </thead>
          <tbody className="">

            {clinetsData.map((e: User) => {
              return (
                <ClientsTableRow key={e.id} data={e} />
              )
            })}
          </tbody>
        </table>
      </div>
      {clientsSearchData ? "" : <div className="flex flex-col gap-5  items-center border-t border-gray-200 bg-white px-4 py-3 sm:px-6 justify-between w-full selection:bg-none">
        <div className="flex flex-1 justify-center  sm:hidden">
          <a
            onClick={() => activePage > 1 && pagination(activePage - 1)}
            className={`relative inline-flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium ${activePage === 1
              ? "bg-gray-100 text-gray-400 cursor-not-allowed"
              : "bg-white text-gray-700 hover:bg-gray-50 cursor-pointer"
              }`}
          >
            {t("clients.previous")}
          </a>

          <a
            onClick={() => activePage < totalPages && pagination(activePage + 1)}
            className={`relative ml-3 inline-flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium ${activePage === totalPages
              ? "bg-gray-100 text-gray-400 cursor-not-allowed"
              : "bg-white text-gray-700 hover:bg-gray-50 cursor-pointer"
              }`}
          >
            {t("clients.next")}
          </a>

        </div>
        <div className="flex sm:justify-between justify-center mx-auto items-center w-full">
          <div className="">
            <p className="text-sm text-gray-700 flex items-center gap-5">
              <span>
                {t("clients.show")}
                <span onClick={() => selectRef.current?.click()} className="font-medium text-sidebar px-2">

                  <select ref={selectRef} className="  border rounded-md  text-center" value={pageNum} onChange={(e) => {
                    dispatch(resetPage());
                    setPageNum(+e.target.value)
                    getClientsData()
                  }}>

                    <option className=" block" value="10">10</option>
                    <option className=" block" value="20">20</option>
                    <option className=" block" value="30">30</option>
                    <option className=" block" value="40">40</option>
                    <option className=" block" value="50">50</option>
                  </select>
                </span>
              </span>

              <span>
                <span >{t("clients.results")} <span className="font-medium text-sidebar px-2">{totalClinets}</span ></span>
                {t("clients.title")}
              </span>
            </p>
          </div>
          <div className="hidden sm:flex  sm:items-center ">
            <div>
              <nav
                aria-label="Pagination"
                className="isolate inline-flex -space-x-px rounded-md shadow-sm"
              >
                {/* Left Button */}
                <a
                  onClick={() => activePage > 1 && pagination(activePage - 1)}
                  className={`relative inline-flex items-center px-2 py-2 text-sm font-medium
      ${lang === "ar" ? "rounded-r-md" : "rounded-l-md"}
      ${activePage === 1
                      ? "text-gray-300 cursor-not-allowed"
                      : "text-gray-400 cursor-pointer hover:bg-gray-50"}
      ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0`}
                >
                  {lang === "ar" ? <FaAnglesRight /> : <FaAnglesLeft />}
                </a>

                {/* Page Numbers */}
                {[...Array(totalPages)].map((_, index) => {
                  const page = index + 1;
                  return (
                    <a
                      key={page}
                      onClick={() => {
                        pagination(page);
                        setActivePage(page);
                      }}
                      className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold
          ${page === activePage
                          ? "bg-sidebar text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sidebar"
                          : "text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"}
          cursor-pointer`}
                    >
                      {page}
                    </a>
                  );
                })}

                {/* Right Button */}
                <a
                  onClick={() => activePage < totalPages && pagination(activePage + 1)}
                  className={`relative inline-flex items-center px-2 py-2 text-sm font-medium
      ${lang === "ar" ? "rounded-l-md" : "rounded-r-md"}
      ${activePage === totalPages
                      ? "text-gray-300 cursor-not-allowed"
                      : "text-gray-400 cursor-pointer hover:bg-gray-50"}
      ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0`}
                >
                  {lang === "ar" ? <FaAnglesLeft /> : <FaAnglesRight />}
                </a>
              </nav>


            </div>
          </div>
        </div>
      </div>
      }
    </>



  )
}

export default Clients
